"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EduHomeInitRequest = void 0;
var EduHomeInitRequest = /** @class */ (function () {
    function EduHomeInitRequest() {
    }
    return EduHomeInitRequest;
}());
exports.EduHomeInitRequest = EduHomeInitRequest;
;
//# sourceMappingURL=eduHomeInit.request.js.map